import { render, staticRenderFns } from "./ZoomIcon.vue?vue&type=template&id=32c6af70&"
import script from "./ZoomIcon.vue?vue&type=script&lang=ts&"
export * from "./ZoomIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports